import React, { useContext, useEffect } from "react";
import dayjs, { Dayjs } from 'dayjs';
import UserLoginContext from "../context/userLoginContext";
import { formatDate, getMonthFromRange } from "../page-components/events/utils/utils";
import { useBaseComponent } from "../base/base-component";
import { ICustomCalendarEvents, IState } from "../page-components/events/type/events.types";
import useEventData from "../custom_hooks/useEventData";
import { WISHES } from "../page-components/celebrations/component/celebration-message";
import { cancelEvent, deleteEvent } from "../page-components/events/action/events.actions";
import EventView from "../page-components/events/events.view";
import '../styles/component/events.scss';

const Events = () => {

    const {user} = useContext(UserLoginContext);
    const today = dayjs();
    const {startDate: initialStartDate, endDate: initialEndDate} = getMonthFromRange(today, today);

    const {state, updateState} = useBaseComponent<{}, IState>({}, {
        initialState: () => ({
            data: {},
            internal: {
                modalState: {
                    mode: 'add',
                    open: false,
                    defaultFormData: undefined
                },
                activeRange: {
                    start: initialStartDate,
                    end: initialEndDate,
                }
            }
        })
    });

    const {data, refetch} = useEventData({
        startDate: formatDate(state.internal.activeRange.start),
        endDate: formatDate(state.internal.activeRange.end)
    });

    useEffect(() => {
        MapEventData();
    }, [data])

    function MapEventData() {
        const getRandomWish = (
            type: "BIRTHDAY" | "WORK_ANNIVERSARY",
            employeeId: string
        ) => {
            const wishes = WISHES[type];
            let hash = 0;
            for (let i = 0; i < employeeId.length; i++) {
                hash = (hash + employeeId.charCodeAt(i)) % wishes.length;
            }
            return wishes[hash];
        };
        const anniversaryData = data.workAnniversaries?.map((item) => {
            return {
                ...item,
                description: getRandomWish("WORK_ANNIVERSARY", item.employeeId),
                hostBy: 'Birthday Bliss Committee',
                venue: 'Okruti Hall'
            }
        });
        const birthdayData = data.birthdays?.map((item) => {
            return {
                ...item,
                description: getRandomWish("BIRTHDAY", item.employeeId),
                hostBy: 'Birthday Bliss Committee',
                venue: 'Okruti Hall'
            }
        });

        updateState('data',
            {
                events: data.events,
                birthdays: birthdayData,
                workAnniversaries: anniversaryData,
                trainingEvents: data.trainingEvents
            });
    }

    function upsertEvent(event: ICustomCalendarEvents) {
        //custom events update and insertion
        const updated = state.data.events?.some((e) => e.id === event.id);
        if (updated) {
            updateState(
                'data',
                {
                    ...state.data,
                    events: state.data.events?.map((e) => (e.id === event.id ? event : e))

                }
            );
        } else {
            //in case of new event is added - re-fetch the data
            refetch();
            MapEventData()
        }


        console.log('event updated', updated)
    }

    const openAddEventModal = () => {
        updateState('internal.modalState', {
            open: true,
            mode: 'add',
            defaultFormData: null
        });
    }

    const closeEventModal = () => {
        updateState('internal', {
            ...state.internal,
            selectedEventId: null,
            modalState: {
                open: false,
                mode: 'add',
                defaultFormData: null
            }
        });
    }

    function openEditEventModal(eventId: string) {
        const allEvents = [...(state.data.events || []), ...(state.data.trainingEvents || [])]
        const selectedEvent = allEvents?.find((e: any) => e.id === eventId);

        if (selectedEvent) {
            updateState('internal', {
                ...state.internal,
                selectedEventId: eventId,
                modalState: {
                    open: true,
                    mode: 'edit',
                    defaultFormData: selectedEvent
                }
            });

        }
    }

    const handleDeleteEvent = async (eventId: string) => {
        try {
            await deleteEvent(eventId);
            const updatedEvents = state.data.events?.filter((event) => event.id !== eventId);
            updateState('data', {
                ...state.data,
                events: updatedEvents
            });

        } catch (error) {
            console.log(error);
        }
    };
    const handleCancelEvent = async (eventId: string, reason: string) => {
        try {
            await cancelEvent(eventId, reason);
            const updatedEvents = state.data.events?.map((event) =>
                event.id === eventId
                    ? {...event, eventStatus: "CANCELLED"}
                    : event
            );
            updateState('data', {
                ...state.data,
                events: updatedEvents
            });
        } catch (error) {
            console.log(error);
        }
    };

    async function onRangeChange(start: Dayjs, end: Dayjs) {
        updateState('internal.activeRange', {
            start,
            end
        });

    }


    return (
        <EventView
            isAdmin={user.isAdmin}
            eventData={state.data}
            modalState={state.internal.modalState}
            openAddEventModal={openAddEventModal}
            closeEventModal={closeEventModal}
            openEditEventModal={openEditEventModal}
            handleDeleteEvent={handleDeleteEvent}
            upsertEvent={upsertEvent}
            onRangeChange={onRangeChange}
            activeRange={state.internal.activeRange}
            handleCancelEvent={handleCancelEvent}
        />
    )

}

export default Events;
